<template>
	<div>
<!--		<div :key="index" v-for="(venta, index) in ventas_cliente" v-if="has_ventas">-->
		<div class="align-content-center">
<!--			<hr v-if="venta.pintar_separador" class="separador_venta primary">-->
			<hr class="separador_venta primary">
<!--			<MiniVenta :venta="venta" @on_click="on_venta_clicked" />-->
			<MiniVentaOnline  venta/>
		</div>
<!--		<div v-else>-->
<!--			<p>No hay ventas que mostrar</p>-->
<!--		</div>-->
	</div>
</template>

<script>
export default {
	name: "VentasClienteOnline",
	components: {
		MiniVentaOnline: () => import('@/views/Ventas/components/MiniVentaOnline')
	},
	data () {
		return {
			ventas_cliente: []
		}
	},

	methods: {
		// async get_ventas_cliente(id_cliente) {
		// 	const resp = await this.$store.dispatch('venta/get_ventas', {
		// 		cliente__id__exact: id_cliente
		// 	})
		// 	if (!resp.success)
		// 		return this.show_error(resp)
		// 	this.ventas_cliente = resp.data
		// 	this.parse_ventas()
		// },

		parse_ventas() {
			const today = this.$moment(new Date()).format('YYYY-MM-DD')
			for (let venta of this.ventas_cliente) {
				if (today > venta.fecha) {
					venta.pintar_separador = true
					return
				}
			}
		},

		on_venta_clicked(venta) {
			this.$emit('on_venta_clicked', venta)
		},

		show_error(response) {
      this.$snotify.error(
        this.$t("Ha ocurrido un error"),
        this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
      )
		}
	},

	mounted() {
		// this.get_ventas_cliente(this.id_cliente)
	},

	computed: {
		// has_ventas() {
		// 	return !!this.ventas_cliente;
		// }
	},

	props: {
		id_cliente: {
			required: true
		}
	}
}
</script>

<style lang="scss" scoped>
.separador_venta {
	border: 1px dashed white !important;
}
</style>